import React, { useRef } from 'react';
import InputGroup, { Props as InputGroupProps } from './InputGroup';
import { Controller, RegisterOptions } from 'react-hook-form';

type Props = InputGroupProps & {
    name: string;
    form: any;
    hideMessageLength?: boolean;
    placeholder?: string;
    clickInText?: boolean;
    onClickInText?: () => void;
    rules?: Exclude<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
    removeInputBorderRadius?: boolean;
    removeIconOrTextBorderRadius?: boolean;
};

const InputGroupController = ({ name, form, hideMessageLength, placeholder, onValueChange, clickInText, onClickInText, rules, removeInputBorderRadius, 
    removeIconOrTextBorderRadius, ...props }: Props, ref: any) => {
    ref = useRef(null);
    return (
        <Controller
            control={form.control}
            name={name}
            render={({ onChange: controllerOnChange, value }) => {
                return (
                    <InputGroup
                        hideMessageLength={hideMessageLength}
                        value={value}
                        name={name}
                        clickInText={clickInText}
                        onClickInText={onClickInText}
                        ref={ref as any}
                        placeholder={placeholder}
                        {...props}
                        onValueChange={value => {
                            const newValue = props.type === 'number' || props.type === 'integer' ? Number(value) : value;
                            controllerOnChange(onValueChange ? onValueChange(newValue) : newValue);
                        }}
                        removeInputBorderRadius={removeInputBorderRadius}
                        removeIconOrTextBorderRadius={removeIconOrTextBorderRadius}
                    />
                );
            }}
            defaultValue={form.getValues(name) ?? ''}
            onFocus={() => (ref.current as any).focus()}
            rules={rules}
        />
    );
};

export default React.forwardRef<HTMLInputElement, Props>(InputGroupController);
